import { Icon } from '@iconify/react';

const ReportShell = ({ title, subtitle, actions, filters, children }) => {
    return (
        <div className="tw-p-5 tw-bg-gradient-to-br tw-from-gray-50 tw-to-slate-50 tw-min-h-screen">
            <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden">
                {/* Header */}
                <div className="tw-p-4 tw-border-b tw-border-gray-100 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
                    <div>
                        <h1 className="tw-text-base tw-font-bold tw-text-gray-800">{title}</h1>
                        {subtitle && <p className="tw-text-[11px] tw-text-gray-500 tw-mt-0.5">{subtitle}</p>}
                    </div>
                    {actions && <div className="tw-flex tw-items-center tw-gap-2">{actions}</div>}
                </div>

                {/* Filters bar */}
                {filters && (
                    <div className="tw-p-4 tw-border-b tw-border-gray-100 tw-bg-gray-50/50">
                        {filters}
                    </div>
                )}

                {/* Body */}
                {children}
            </div>
        </div>
    );
};

export const ReportActionButtons = ({ onCollapseAll, onExcel, onPrint, collapseAllLabel = 'Collapse All' }) => (
    <>
        {onCollapseAll && (
            <button
                onClick={onCollapseAll}
                className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors"
            >
                <Icon icon="mdi:chevron-up" className="tw-text-sm" />
                {collapseAllLabel}
            </button>
        )}
        {onExcel && (
            <button
                onClick={onExcel}
                className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors"
            >
                <Icon icon="mdi:download" className="tw-text-sm" />
                Excel
            </button>
        )}
        {onPrint && (
            <button
                onClick={onPrint}
                className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-transition-colors"
            >
                <Icon icon="mdi:printer-outline" className="tw-text-sm" />
                Print
            </button>
        )}
    </>
);

export default ReportShell;
